import { CreateRoomType } from "../models/RoomType";
import { axiosInstance } from "./AxiosDefaults";

export const getAllroomType = (): Promise<any> => {
  return axiosInstance.get(
    //TODO: izmeniti da dobija smestaje iz liste svih dogadjaja
    "/roomType",
    {
      withCredentials: false,
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const getRoomType = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/roomType`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getEventXRoomType = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/eventXRoomType`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createARoomType = (roomType: CreateRoomType): Promise<any> => {
  return axiosInstance.post("/roomType", roomType, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateRoomType = async (
  id: string,
  roomType: CreateRoomType
): Promise<any> => {
  return axiosInstance.put(`${"/roomType"}/${id}`, roomType, {
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteRoomType = (id: string): Promise<any> => {
  return axiosInstance.delete(`${"/roomType"}/${id}`);
};
